angular.module('wbControllers').controller 'FundPageController',
['$scope', '$location', 'railsResource', '$window',
($scope, $location, $resource, $window) ->
  cusip = $location.search().cusip
  if !cusip
    $window.location = '/404'

  Holding = $resource '/holdings/:id', { id: '@id' }
  HoldingPrice = $resource '/holdings/:id/prices', { id: '@id' }
  $scope.performanceChart = {
    range: 'all',
    data: null
  }

  if cusip
    $scope.etf = Holding.get { cusip: cusip }, (h) =>
      HoldingPrice.query { id: h.id }, (prices) ->
        $scope.performanceChart.allData = prices
        $scope.performanceChart.data = prices
      $scope.sectorArray = for name, value of h.sectors
        {'name': name, 'value': value}
      $scope.sectorArray = _.filter $scope.sectorArray, (s) -> +s.value > 0
      $scope.bondRatingsArray = for name, value of h.bondRatings
        {'name': name, 'value': value}

  $scope.$watch 'performanceChart.range', (range) ->
    allData = $scope.performanceChart.allData
    $scope.performanceChart.data = switch range
      when 'all' then allData
      when 'ytd'
        start = moment().startOf('year')
        _.filter allData, (p) -> moment(p.priceDate) > start
      else
        start = moment().subtract(+range[0], range[1])
        _.filter allData, (p) -> moment(p.priceDate) > start

  $scope.hasHoldings = (etf) ->
    _.some etf.holdings, (h) -> +h.weight > 0
  $scope.hasSectors = (etf) ->
    _(etf.sectors).values().some (v) -> +v > 0
  $scope.hasBondRatings = (etf) ->
    _(etf.bondRatings).values().some (v) -> +v > 0
]
